import React, { useRef, useState } from "react";
import { GetAvailableMachinesForReplaceType, GetBlendersType, GetBoardsType, GetDiagnosisType, GetLocationsType, GetTubeShieldsType } from "../../../models/_publicCall";
import Select from "react-select";
import { SiteVisitationMachine } from "../SiteVisitation";
import TicketsInfo from "./TicketsInfo";
import { GetMachineServiceType } from "../../../models/_tickets";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-responsive-modal";
import Moment from 'moment';

const MachineInfo = (props: {
  values: any;
  handleChange: any;
  handleBlur: any;
  setFieldValue: any;
  logJob: any;
  tubeShieldsDB: GetTubeShieldsType[];
  blendersDB: GetBlendersType[];
  siteVisitationMachines: { [machineId: string]: SiteVisitationMachine };
  setSiteVisitationMachines: (value: { [machineId: string]: SiteVisitationMachine }) => void;
  keepTicketOpen: { [ticketId: string]: boolean };
  diagnosis: GetDiagnosisType[];
  machineServicesDB: GetMachineServiceType[];
  machinesDB: GetAvailableMachinesForReplaceType[],
  locationsDB: GetLocationsType[]
  boardsDB: GetBoardsType[],
  replaceNewTubeDoors1mmShorter: { [ticketId: string]: boolean };
  convertTicketToLabTicket: { [ticketId: string]: boolean };
  replacedBlender: { [ticketId: string]: string };
  replacedBoard: { [ticketId: string]: string };
  onSelectedDiagnosesChange: (selected: { [ticketId: string]: string[] }) => void;
  onSelectedMachineServicesDoneChange: (selected: { [ticketId: string]: string[] }) => void;
  onMachineServicesDoneOtherChange: (selected: { [ticketId: string]: string }) => void;
  setReplaceNewTubeDoors1mmShorter: (selected: { [ticketId: string]: boolean }) => void;
  setConvertTicketToLabTicket: (selected: { [ticketId: string]: boolean }) => void;
  setReplacedBlender: (selected: { [ticketId: string]: string }) => void;
  setReplacedBoard: (selected: { [ticketId: string]: string }) => void;
  onDaignosisOtherChange: (selected: { [ticketId: string]: string }) => void;
  setKeepTicketOpen: (selected: { [ticketId: string]: boolean }) => void;
}) => {
  const { blendersDB, tubeShieldsDB, siteVisitationMachines, setSiteVisitationMachines,logJob,
    machinesDB,
    boardsDB,
    locationsDB,
    
    replacedBlender,
    replacedBoard,
    convertTicketToLabTicket,
    diagnosis,
    machineServicesDB,
    replaceNewTubeDoors1mmShorter,
    keepTicketOpen,
    setConvertTicketToLabTicket,
    setReplacedBlender,
    setReplacedBoard,
    onSelectedDiagnosesChange,
    onSelectedMachineServicesDoneChange,
    onMachineServicesDoneOtherChange,
    onDaignosisOtherChange,
    setReplaceNewTubeDoors1mmShorter,
    setKeepTicketOpen,
   } = props;
  const [collapsedMachines, setCollapsedMachines] = useState<boolean[]>(
    Array(logJob?.machines?.length).fill(true) // All machines start as collapsed
  );
  const machineIdRefs = useRef<{ [machineId: string]: any }>({}); // Dynamic refs for each ticket
  const [showNewMachineActiveLocationWarningPopup, setShowNewMachineActiveLocationWarningPopup] = useState(false);
    const [tempReplaceMachineTicketInfo, setTemplReplaceMachineTicketInfo] = useState<{ oldMachineId?: string, machineId?: string, locationName?: string }>({});
    const [tempOldMachineShiftLocationMachineId, setTempOldMachineShiftLocationMachineId] = useState<string>("");
    const [showOldMachineShiftLocationPopup, setShowOldMachineShiftLocationPopup] = useState(false);
  const toggleCollapse = (index: number) => {
    setCollapsedMachines(prev => ({ ...prev, [index]: !prev[index] }));
  };

   const replaceMachine = () => {
      if (!tempReplaceMachineTicketInfo.oldMachineId || !tempReplaceMachineTicketInfo.machineId) return;

      setSiteVisitationMachines({
        ...siteVisitationMachines,
        [tempReplaceMachineTicketInfo.oldMachineId]: {
          ...siteVisitationMachines[tempReplaceMachineTicketInfo.oldMachineId],
          newMachineId: tempReplaceMachineTicketInfo.machineId
        },
      })
      setTempOldMachineShiftLocationMachineId(tempReplaceMachineTicketInfo.oldMachineId)
      setShowNewMachineActiveLocationWarningPopup(false)
      setTemplReplaceMachineTicketInfo({})
      setShowOldMachineShiftLocationPopup(true)
    }
  
    const handleClose = () => {
      setShowNewMachineActiveLocationWarningPopup(false)
      if (tempReplaceMachineTicketInfo.oldMachineId) {
        if (machineIdRefs.current[tempReplaceMachineTicketInfo.oldMachineId]) {
          machineIdRefs.current[tempReplaceMachineTicketInfo.oldMachineId].clearValue();
        }
      }
  
      setTemplReplaceMachineTicketInfo({})
    }
  return (
    <div className="wo-form-section mt-8">
      {siteVisitationMachines && Object.keys(siteVisitationMachines).length > 0 ? (
        Object.values(siteVisitationMachines).map((machine: any, index: number) => {
          
          const currentBlender = blendersDB.find((b: any) => String(b.id) === String(machine.blenderId))
          const currentTubeShield = tubeShieldsDB.find((b: any) => String(b.id) === String(machine.tubeDoorId))
          const blenderDefaultValue = currentBlender && machine.blenderId
          ? { label: currentBlender.title, value: machine.blenderId }
          : {}
          const machineTickets = logJob?.tickets.filter((ticket: any) => ticket.machineId === machine.id);
         
          return (
            <div key={index} className="border-dotted border-2 border-gray-200 p-8 gap-2 mb-8 ">
             <div className="d-flex align-items-center justify-content-between w-100" onClick={() => toggleCollapse(index)}>
                  <h3 className="mb-0">{machine?.name} {machine?.serialNumber}</h3>
                    <button
                      type="button"
                      className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg border-0"
                      
                    >
                      {collapsedMachines[index] ? <i className="bi bi-chevron-down fs-2"></i> : <i className="bi bi-chevron-up fs-2"></i>}
                    </button>
                </div>
             <div className={`mt-2 ${collapsedMachines[index] ? "d-none" : "d-block"}`}>
                {/* Machine Name & Serial Number */}
                <div className="d-flex align-items-center gap-2">
                  <label className="wo-label mb-0 fw-semibold">Machine Name:</label>
                  <span className="mb-0 fw-bold">{machine?.name}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label className="wo-label mb-0 fw-semibold">Serial Number:</label>
                  <span className="mb-0 fw-bold">{machine?.serialNumber}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label className="wo-label mb-0 fw-semibold">Software version:</label>
                  <span className="mb-0 fw-bold">{machine?.softwareVersion}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label className="wo-label mb-0 fw-semibold">Hardware Note:</label>
                  <span className="mb-0 fw-bold">{machine?.mechanicalHardwareNote || ''}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label className="wo-label mb-0 fw-semibold">Last heartbeat at:</label>
                  <span className="mb-0 fw-bold">{machine?.lastHeartbeatAt ? Moment.utc(machine.lastHeartbeatAt)
                                              .local()
                                              .format("YYYY-MM-DD HH:mm:ss") : ''}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label className="wo-label mb-0 fw-semibold">Last sanitizer replaced at:</label>
                  <span className="mb-0 fw-bold">{machine?.lastSanitizerReplacedAt ? Moment.utc(machine.lastHeartbeatAt)
                                              .local()
                                              .format("YYYY-MM-DD HH:mm:ss") : ''}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <label className="wo-label mb-0 fw-semibold">Last filter replaced at:</label>
                  <span className="mb-0 fw-bold">{machine?.lastFilterReplacedAt ? Moment.utc(machine.lastFilterReplacedAt)
                                              .local()
                                              .format("YYYY-MM-DD HH:mm:ss") : ''}</span>
                </div>
                <TicketsInfo
                  tickets={machineTickets}
                  logJob={logJob}
                  diagnosis={diagnosis}
                  machinesDB={machinesDB}
                  blendersDB={blendersDB}
                  boardsDB={boardsDB}
                  machineServicesDB={machineServicesDB}
                  locationsDB={locationsDB}
                  onSelectedDiagnosesChange={onSelectedDiagnosesChange}
                  setReplaceNewTubeDoors1mmShorter={setReplaceNewTubeDoors1mmShorter}
                  replaceNewTubeDoors1mmShorter={replaceNewTubeDoors1mmShorter}
                  setReplacedBoard={setReplacedBoard}
                  replacedBoard={replacedBoard}
                  setReplacedBlender={setReplacedBlender}
                  setConvertTicketToLabTicket={setConvertTicketToLabTicket}
                  convertTicketToLabTicket={convertTicketToLabTicket}
                  replacedBlender={replacedBlender}
                  siteVisitationMachines={siteVisitationMachines}
                  onSelectedMachineServicesDoneChange={
                    onSelectedMachineServicesDoneChange
                  }
                  onMachineServicesDoneOtherChange={
                    onMachineServicesDoneOtherChange
                  }
                  setSiteVisitationMachines={
                    setSiteVisitationMachines
                  }
                  onDaignosisOtherChange={
                    onDaignosisOtherChange
                  }
                  keepTicketOpen={keepTicketOpen}
                  setKeepTicketOpen={setKeepTicketOpen}
                  />
                {/* Toggle Switches - Right Aligned */}
                <div className="mt-4">
                  {[
                    { label: "Machine has Polyfuses", name: "hasPolyfuses" },
                    { label: "Made 4 smoothies", name: "made4Smoothies" },
                    {
                      label:
                        "Machine Surface, Blender Bell Wiper, Bottom Wiper are clean",
                      name: "cleanlinessCheck",
                    },
                    {
                      label: "Machine Passed Getstatus",
                      name: "getStatusPassed",
                    },
                    { label: "Flowmeter Activated", name: "flowmeterActivated" },
                    {
                      label: "Water level is calibrated with scale",
                      name: "waterLevelCalibratedWithScale",
                    },
                    {
                      label: "Replace filter",
                      name: "replaceFilter",
                    },
                    {
                      label: "Replace Machine",
                      name: "replaceMachine",
                    },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex justify-content-between align-items-center mb-3"
                    >
                      <label className="wo-label fw-semibold">
                        {item.label}:
                      </label>
                      <div className="form-check form-switch form-check-custom">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={machine[item.name]}
                          onChange={(event) =>
                            setSiteVisitationMachines({
                              ...siteVisitationMachines,
                              [machine.id]: {
                                ...machine,
                                [item.name]: event.target.checked,
                              },
                            })
                          }
                          name={item.name}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="wo-form-section mt-8">
                <div className="d-flex align-items-center justify-content-between">
                      <label className="wo-label">
                      Sanitizer Level:
                      </label>
                      <div>
                        <button
                          type="button"
                          onClick={() =>
                            setSiteVisitationMachines({
                              ...siteVisitationMachines,
                              [machine.id]: {
                                ...machine,
                                sanitizerLevel: "LOW",
                              },
                            })} // ✅ Store in values
                          className={`btn me-2 ${siteVisitationMachines[machine.id] && siteVisitationMachines[machine.id].sanitizerLevel === "LOW"
                              ? "btn-primary"
                              : "btn-light text-dark"
                            }`}
                        >
                          Low
                        </button>

                        <button
                          type="button"
                          onClick={() => setSiteVisitationMachines({
                            ...siteVisitationMachines,
                            [machine.id]: {
                              ...machine,
                              sanitizerLevel: "MEDIUM",
                            },
                          })} // ✅ Store in values
                          className={`btn me-2 ${siteVisitationMachines[machine.id] && siteVisitationMachines[machine.id].sanitizerLevel === "MEDIUM"
                              ? "btn-primary"
                              : "btn-light text-dark"
                            }`}
                        >
                          Medium
                        </button>

                        <button
                          type="button"
                          onClick={() => setSiteVisitationMachines({
                            ...siteVisitationMachines,
                            [machine.id]: {
                              ...machine,
                              sanitizerLevel: "HIGH",
                            },
                          })} // ✅ Store in values
                          className={`btn ${siteVisitationMachines[machine.id] && siteVisitationMachines[machine.id].sanitizerLevel === "HIGH"
                              ? "btn-primary"
                              : "btn-light text-dark"
                            }`}
                        >
                          High
                        </button>
                      </div>
                    </div>
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label fs-4 fw-bold">Blender</label>
                  <Select
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="blender"
                    value={blenderDefaultValue}
                    placeholder=""
                    onChange={(e: any) => {
                      setSiteVisitationMachines({
                        ...siteVisitationMachines,
                        [machine.id]: {
                          ...machine,
                          blenderId: e.value,
                        },
                      });
                    }}
                    options={blendersDB.map((value: any) => {
                      return {
                        value: value.id,
                        label: value.title,
                      };

                    })}
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label fs-4 fw-bold">Tube Door Shield</label>
                  <Select
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="tubeDoorId"
                    value={
                      currentTubeShield
                        ? { label: currentTubeShield.name, value: currentTubeShield.id }
                        : null
                    }
                    placeholder=""
                    onChange={(e: any) => {
                      setSiteVisitationMachines({
                        ...siteVisitationMachines,
                        [machine.id]: {
                          ...machine,
                          tubeDoorId: e.value,
                        },
                      });
                    }}
                    options={tubeShieldsDB.map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };

                    })}
                  />
                </div>

                {machine.replaceMachine ? (
                                        <>
                                        <div className="">
                                          <label className="form-label required fs-4 fw-bold">
                                            New Machine
                                          </label>
                                          <Select
                                            className="react-select"
                                            classNamePrefix="my-react-select"
                                            name="machineId"
                                            placeholder="Please select new machine"
                                            ref={(el) => (machineIdRefs.current[machine.id] = el)}
                                            value={machine.newMachineId ? {
                                              label: machinesDB.find((value: any) => value.id === machine.newMachineId)?.machine_name ? machinesDB.find((value: any) => value.id === machine.newMachineId)?.machine_name : (machinesDB.find((value: any) => value.id === machine.newMachineId)?.location_name ?? "") + " " + machinesDB.find((value: any) => value.id === machine.newMachineId)?.serial_number,
                                              value: machine.newMachineId,
                                            } : {}}
                                            options={Array.from(machinesDB).filter((record) => record.id !== machine.id).map((value: any) => {
                                              return {
                                                value: value.id,
                                                label: `${value.machine_name ? value?.machine_name : (value?.location_name ?? "")} ${value?.serial_number}`,
                                              };
                                            })}
                                            onChange={(e: any) => {
                                              if (e.value === machine.id) {
                                                toast.error("Please select another machine.");
                                                return;
                                              }
                                              
                
                
                                              const selectedMachine = machinesDB.find((record: any) => machine.id === e.value);
                                              if (machine?.location_id && machine?.site_status) {
                                                setShowNewMachineActiveLocationWarningPopup(true)
                                                setTemplReplaceMachineTicketInfo({
                                                  oldMachineId: machine.id,
                                                  machineId: e.value,
                                                  locationName: machine.location_name
                                                })
                                                return;
                                              }
                                              
                                              setTempOldMachineShiftLocationMachineId(machine.id);
                                              setShowOldMachineShiftLocationPopup(true)
                                              setSiteVisitationMachines({
                                                ...siteVisitationMachines,
                                                [machine.id]: {
                                                  ...machine,
                                                  newMachineId: e.value,
                                                },
                                              })
                                              
                                            }}
                                          />
                
                                        </div>
                                          {
                                            machine.oldMachineShiftToLocationId && 
                                            (
                                              <div className="form-label mt-5 mb-5">
                                                Old machine will be shif to: {locationsDB.find(location => location.id === machine.oldMachineShiftToLocationId)?.name} location
                                              </div>
                                            )
                                          }
                                        </>
                                      ) : (
                                        ""
                                      )}

{(machine.replaceMachine) ?
                        <>
                          <div className="row">
                            <div className="">
                              <label className="form-check form-check-custom form-check-solid me-5 d-flex align-items-center">
                                <input
                                  id="convertToLabTicket"
                                  type="checkbox"
                                  name="convertToLabTicket"
                                  className="form-check-input"
                                  checked={machine.convertToLabTicket || false}
                                  onChange={(e) => {
                                    setSiteVisitationMachines({
                                      ...siteVisitationMachines,
                                      [machine.id]: {
                                        ...machine,
                                        convertToLabTicket: e.target.checked
                                      },
                                    })
                                  }}
                                />
                                <span
                                  className="form-label fw-bold mt-2 ms-3 fs-3"
                                  style={{ cursor: "pointer" }}
                                >
                                  Do you want to convert all open tickets to lab ticket?
                                </span>
                              </label>
                            </div>
                          </div>
                        </>
                        : ""}
              </div>
            </div>
          )
        })

        
      ) : (
        <p className="text-muted">No machine data available.</p>
      )}

      <Modal
        open={showNewMachineActiveLocationWarningPopup}
        onClose={() => setShowNewMachineActiveLocationWarningPopup(false)}
        role="modal"
        center
        classNames={{
          root: "content-wrapper",
        }}
      >
        <div className='modal-title'></div>
        <div className="modal-body p-2">
          <h4 className=" fs-4 mb-8 mt-4">This machine is already activated at {tempReplaceMachineTicketInfo.locationName} do you want to replace machine</h4>
        </div>
        <div className="modal-footer justify-content-center p-2">
          <button className="btn btn-primary me-4 ml-4 col-3 mt-4" onClick={() => replaceMachine()}>Yes </button>
          <button className="btn btn-secondary col-3 mt-4" onClick={() => handleClose()}>No </button>
        </div>
      </Modal>

      <Modal open={showOldMachineShiftLocationPopup} onClose={() => {
        setShowOldMachineShiftLocationPopup(false)
        setTempOldMachineShiftLocationMachineId("")
      }} center classNames={{ root: "content-wrapper" }}>
        <div className="modal-title"></div>
        <div className="modal-body p-2">
          <div className="card">
          <label className="form-label fs-4 fw-bold">
            Where you want to shift old machine ?
          </label>
          <Select
            className="react-select"
            classNamePrefix="my-react-select"
            name="oldMachineShiftToLocationId"
            placeholder=""

            options={Array.from(locationsDB).map((value: any) => {
              return {
                value: value.id,
                label: value.name,
              };
            })}
            onChange={(e: any) => {
              const selectedId = e.value;
              setSiteVisitationMachines({
                ...siteVisitationMachines,
                [tempOldMachineShiftLocationMachineId]: {
                  ...siteVisitationMachines[tempOldMachineShiftLocationMachineId],
                  oldMachineShiftToLocationId: selectedId,
                },
              });
            }}
          />
          </div>
        </div>
        <div className="modal-footer justify-content-center p-2">
          <button className="btn btn-secondary col-3 mt-4" onClick={() => {setShowOldMachineShiftLocationPopup(false)
            setTempOldMachineShiftLocationMachineId("")}
          }>Close </button>
        </div>


      </Modal>
      <Toaster
                position="bottom-left"
                reverseOrder={false}
                gutter={8}
                containerClassName=""
                containerStyle={{}}
                toastOptions={{
                  className: "",
                  duration: 3000,
                }}
              />
    </div>
  );
};

export default MachineInfo;
